import { BASE_DOMAIN, BASE_URL, BASE_RESOURCE_URL } from '../constants';

export const API = {
  WEBSOCKET: `wss://${BASE_DOMAIN}/ws`,
  ////// CHECK BALANCE
  GET_BALANCE: `${BASE_URL}/api/Customer`,
  ////// SHARE ALL
  IMG_URL: `${BASE_RESOURCE_URL}/image/`,
  BANNER_IMG_URL: `${BASE_RESOURCE_URL}/image/banner`,
  PRODUCT_IMG_URL: `${BASE_RESOURCE_URL}/image/product/`,
  REVIEW_IMG_URL: `${BASE_RESOURCE_URL}/image/review`,

  ////// HOME API
  NAVBAR_CATEGORY: `${BASE_URL}/api/Category/NameCategories`,
  ITEM_BY_CATEGORY: `${BASE_URL}/api/Category/ItemCategories`,

  ////// VOUCHER API
  GET_VOUCHER_ITEM: `${BASE_URL}/api/Voucher`,
  GET_VOUCHER_EACH_ITEM: `${BASE_URL}/api/Voucher/name/`,
  GET_VOUCHER_ORDER_BY_ID: `${BASE_URL}/api/voucher/selectVoucherOrderById`,

  HERO_SLIDER: `${BASE_URL}/api/Hero`,
  NEW_ARRIVALS: `${BASE_URL}/api/Item/new-items`,
  ////// SEARCH API
  SEARCH: `${BASE_URL}/api/Item/search/`,
  ////// SINGLE PRODUCT API
  PRODUCT_BY_MODEL: `${BASE_URL}/api/Item/name/`,

  ////// CART API
  CREATE_CART: `${BASE_URL}/api/Cart/`,
  GET_CART_DATA: `${BASE_URL}/api/Cart/`,
  GET_CART_ITEM_STOCK: `${BASE_URL}/api/cart/updateitemstock`,
  UPDATE_CART_DATA: `${BASE_URL}/api/Cart/`,
  DELETE_CART: `${BASE_URL}/api/Cart/`,
  GET_SHIPPING_COST: `${BASE_URL}/api/cart/shippingCost`,
  GET_PROMOTION: `${BASE_URL}/api/cart/promotion`,
  CHECK_ITEM_ACTIVE: `${BASE_URL}/api/Cart/CheckItemActive`,
  ////// ADDRESS API
  GET_ADDRESS: `${BASE_URL}/api/Address`,
  CREATE_ADDRESS: `${BASE_URL}/api/Address`,
  UPDATE_ADDRESS: `${BASE_URL}/api/Address`,
  DELETE_ADDRESS: `${BASE_URL}/api/Address`,
  ////// TAX ADDRESS API
  GET_TAX_ADDRESS: `${BASE_URL}/api/AddressTaxInvoice`,
  CREATE_TAX_ADDRESS: `${BASE_URL}/api/AddressTaxInvoice`,
  UPDATE_TAX_ADDRESS: `${BASE_URL}/api/AddressTaxInvoice`,
  DELETE_TAX_ADDRESS: `${BASE_URL}/api/AddressTaxInvoice`,

  GET_VOUCHER: `${BASE_URL}/api/voucher/selectvoucherbycustomerid`,

  ////// ORDERING
  ORDERING_SF_PLUS: `${BASE_URL}/api/Pay/SfPlus`,
  ORDERING_CREDIT_CARD: `${BASE_URL}/api/Pay/CreditCard`,
  ORDERING_THAIQR: `${BASE_URL}/api/Pay/ThaiQR`,

  ////// THAIQR PROCESS
  INQUIRE_THAIQR: `${BASE_URL}/api/Pay/ThaiQR/Inquire`,
  CANCEL_THAIQR: `${BASE_URL}/api/Pay/ThaiQR/Cancel`,
  ////// PAYMENT
  GET_K_PAYMENT_HASH: `${BASE_URL}/api/pay/hash-kpayment`,
  GET_2C2P_HASH: `${BASE_URL}/api/pay/hash-2c2p`,
  CONFIRM_PAYMENT: `${BASE_URL}/api/ConfirmPayment`,
  ////// KPAYMENT 
  KPAYMENT_CHARGE: `${BASE_URL}/api/Pay/KPayment`,
  GET_PICKUP_DATE: `${BASE_URL}/api/pay/getprickupdate`,
  ////// USER PROFILE
  GET_PURCHASE_ORDER_BY_CUSTOMER_ID: `${BASE_URL}/api/Order/SelectOrderByCustomerId`,
  GET_PURCHASE_ORDER_BY_ORDER_ID: `${BASE_URL}/api/Order/SelectOrderById`,
  GET_REFUND_ITEMS_BY_CUSTOMER_ID: `${BASE_URL}/api/RefundItem/GetRefundByCustomerId`,
  CREATE_REFUND_ITEM: `${BASE_URL}/api/RefundItem/CreateRefund`,
  GET_PURCHASE_ORDER_BY_INVOICE: `${BASE_URL}/api/Order/SelectOrderByInvoice`,
  GET_PURCHASE_ORDER_OF_GUEST_BY_INVOICE: `${BASE_URL}/api/order/selectguestorder`,

  CREATE_CUSTOMER: `${BASE_URL}/api/Customer`,

  ////// PAYMENT
  GET_PAYMENT_TYPE: `${BASE_URL}/api/paymentGateway`,

  ////// REVIEW
  GET_PRODUCT_REVIEW: `${BASE_URL}​/api/review`,
  POST_PRODUCT_REVIEW: `${BASE_URL}/api/review`,

  ////// POPUP PROMOTION
  POPUP_PROMOTION :`${BASE_URL}/api/popupmodal`,
  POPUP_PROMOTION_IMG_URL: `${BASE_URL}/image/popuppromotion/`,

  GET_BRANCH: `${BASE_URL}/api/branch`,

  GET_BRANCH_SETTING: `${BASE_URL}/api/branchsetting`
};
